import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { APP_ROUTES, FULL_ROUTES } from './constants/routes.const';
import { authorizedTenant } from './guards/redirects.guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/' + FULL_ROUTES.HOME.join('/')
  },
  {
    path: '',
    loadChildren: () => import('./pages/main/main.module').then(m => m.MainPageModule),
    canActivate: [authorizedTenant]
  },
  {
    path: APP_ROUTES.EDUCATION,
    loadChildren: () => import('./pages/education/education.module').then(m => m.EducationPageModule),
    canActivate: [authorizedTenant]
  },
  {
    path: FULL_ROUTES.PLAYER_PROFILE.join("/") + "/:id",
    loadChildren: () => import('./pages/main/player-profile/player-profile.module').then(m => m.PlayerProfilePageModule),
  },
  {
    path: APP_ROUTES.AUTH,
    loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthPageModule)
  },
  {
    path: '404',
    loadChildren: () => import('./pages/error404/error404.module').then(m => m.Error404PageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
